import { type ProductOption, productOptionKeyMap } from "../../../../core/schema/ProductOption.js";
import { minimalOptions } from "../../../../core/schema/productOptionPrices.js";

export function isSimpleToggleProductOption(option: ProductOption): boolean {
	return typeof minimalOptions[productOptionKeyMap[option]] === "boolean";
}
